import { Box, Typography, SvgIcon, IconButton } from '@mui/material';
import { FunctionComponent } from 'react';

import Alert from '@Components/Alert';
import CommonConstants from '@Constants/common.constants';
import Icons from '@Constants/Icons.constants';

import { StyledModal } from './Modal.styles';
import { ModalProps } from './Modal.types';

export const Modal: FunctionComponent<ModalProps> = (
  props: ModalProps
): JSX.Element => {
  const { onClose, headerText, children, alertState, ...resProps } = props;

  /** Header for the Modal takes headerText and gives Header block */
  const header = (
    <Box className="modal-header">
      <Typography variant="input" component="h3" fontWeight="bold">
        {headerText}
      </Typography>
      <IconButton
        onClick={(e) => {
          if (onClose) {
            onClose(e, 'escapeKeyDown');
          }
        }}
      >
        <SvgIcon sx={{ color: 'grey.600' }}>{Icons.close}</SvgIcon>
      </IconButton>
    </Box>
  );

  /** Reset Alert */
  const resetAlert = () => {
    if (alertState?.resetAlert) {
      alertState.resetAlert((prevState) => ({
        ...prevState,
        openAlert: false,
      }));
    }
  };

  return (
    <>
      <Alert
        open={alertState?.openAlert}
        autoHideDuration={CommonConstants.ALERT_HIDING_TIME}
        text={alertState?.message}
        severity={alertState?.severity}
        closeBtnProps={{
          onClick: resetAlert,
        }}
        onClose={resetAlert}
        className="base-alert"
        sx={{
          '&.base-alert': {
            top: '0',
            left: '50%',
            height: '5.6rem',
            transform: 'translateX(-50%)',
          },
        }}
      />
      <StyledModal onClose={onClose} {...resProps}>
        <div className="content">
          {header}
          {children}
        </div>
      </StyledModal>
    </>
  );
};

export default Modal;
